module.exports = __webpack_public_path__ + "video_author_arrow-02df9638.png";